var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3161 4.53327L11.92 4.88197C12.4035 5.16114 12.5692 5.77936 12.29 6.26288L9.06501 11.8487C8.51932 12.7939 7.31063 13.1178 6.36557 12.5721C5.42031 12.0263 5.09638 10.8177 5.64217 9.87245L5.71429 9.74748L4.63742 9.12573L4.56519 9.2507C3.67609 10.7907 4.20375 12.7599 5.74372 13.649C7.28369 14.5381 9.25288 14.0104 10.142 12.4704L13.3669 6.88463C13.9895 5.80641 13.6199 4.42768 12.5417 3.8051L11.9779 3.47961L11.3161 4.53327Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39051 5.60068C7.84128 4.81987 7.57372 3.82144 6.79291 3.37046L5.3319 2.52696C4.64165 2.12841 3.75887 2.36499 3.36033 3.05534L1.48399 6.30512C0.487639 8.031 1.07892 10.2378 2.8048 11.2341L6.05458 13.1105C4.81201 12.3931 4.38622 10.8042 5.10372 9.56154L7.39051 5.60068Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.17805
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1299 0.567461C10.1067 -0.600703 7.51962 0.0925481 6.35166 2.11572L5.86452 2.95944L6.94139 3.58119L7.42843 2.73747C8.25328 1.309 10.0798 0.819581 11.5081 1.64423L12.5565 2.24961C11.893 2.51846 11.3386 3.00167 10.9816 3.62222L7.82883 9.08305C7.54967 9.56657 6.93144 9.73216 6.44792 9.45299L5.45561 8.88015L5.14474 9.41859L4.83386 9.95702L5.82617 10.53C6.90439 11.1524 8.28312 10.783 8.9057 9.7048L12.0585 4.24397C12.6042 3.29881 13.8129 2.97488 14.758 3.52067L15.3798 2.4437L12.1299 0.567461Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17819 9.72127L7.63965 9.41039L7.95052 8.87196L10.9816 3.62231C11.8707 2.08224 13.8397 1.55468 15.3797 2.44368C16.9197 3.33279 17.4473 5.30197 16.5582 6.84194L14.249 10.8418C13.6787 11.8294 12.4157 12.1679 11.428 11.5976L10.178 10.876L10.7998 9.79909L12.0497 10.5207C12.1432 10.5747 12.2463 10.6097 12.3533 10.6238C12.4602 10.6379 12.5689 10.6307 12.6731 10.6028C12.7773 10.5749 12.875 10.5267 12.9606 10.461C13.0462 10.3953 13.118 10.3134 13.172 10.22L15.4814 6.22009C16.0271 5.27503 15.7032 4.06635 14.758 3.52066C13.8128 2.97497 12.6041 3.2988 12.0584 4.24396L9.56873 8.55631L9.0303 8.24544L8.17819 9.72127Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.fd0e104177af2836cf78d0e5281e3879.svg";
export { ForwardRef as ReactComponent };